import React, { useState, useCallback } from 'react';
import { Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SlideUpTransition } from '../../../../Components/Transitions/Transitions';
import BaseDialog from '../../../../Components/Dialogs/BaseDialog';
import BaseButton from '../../../../Components/Buttons/BaseButton';
import { DigitalInvoiceDeactivationStepId } from '../ContractDigitalInvoiceDeactivation';

import GroupRadioForm from '../../../../Components/Radio/GroupRadioForm';
import { Company } from '../../../../Configs/general';
import { DactivationReasonLabels } from '../../contract_enums';

const DeactivationReasonStep = props => {
  const { open, title, onClose, setNextModal, step } = props;

  const contractId = step.data.contractId || '';
  const contractAlias = step.data.contractAlias || '';

  // * STATE HOOKS
  const [
    digitalInvoiceDeactivationReason,
    setDigitalInvoiceDeactivationReason
  ] = useState();
  // * OTHER HOOKS
  const classes = useStyles();

  const isMobileSize = useMediaQuery(theme =>
    theme.breakpoints.down(theme.breakpoints.values.sm)
  );

  const handleGoBack = useCallback(() => {
    setNextModal(previousValue => ({
      ...previousValue,
      type: DigitalInvoiceDeactivationStepId.Validation
    }));
  }, [setNextModal]);

  const handleSubmit = useCallback(() => {
    setNextModal(previousValue => ({
      ...previousValue,
      type: DigitalInvoiceDeactivationStepId.Identification,
      data: {
        ...previousValue.data,
        digitalInvoiceDeactivationReason
      }
    }));
  }, [setNextModal, digitalInvoiceDeactivationReason]);

  //* COMPONENTS

  const renderActions = useCallback(() => {
    return (
      <>
        <BaseButton
          onClick={handleGoBack}
          variant="outlined"
          color="primary"
          size="small"
        >
          Atrás
        </BaseButton>
        <BaseButton
          color="primary"
          size="small"
          disabled={!digitalInvoiceDeactivationReason}
          onClick={handleSubmit}
        >
          Continuar
        </BaseButton>
      </>
    );
  }, [handleGoBack, digitalInvoiceDeactivationReason, handleSubmit]);

  const renderContent = useCallback(() => {
    return (
      <div
        id="DeactivationReasonStep_div_container"
        className={classes.content}
      >
        <Typography className={classes.text}>
          Te invitamos a compartir el motivo por el cual has decidido desactivar
          la factura digital de tu{' '}
          <span className={classes.bold}>
            {Company.contractConjugation.capitalized.singular.main}:{' '}
            {contractId} ({contractAlias})
          </span>{' '}
          . Tu opinión es muy importante para nosotros y nos ayudará a mejorar
          nuestros servicios.
          <br />
          <br />
        </Typography>
        <GroupRadioForm
          labels={DactivationReasonLabels}
          setSelectedReason={setDigitalInvoiceDeactivationReason}
          selectedReason={digitalInvoiceDeactivationReason}
        />
      </div>
    );
  }, [contractId, contractAlias, classes, digitalInvoiceDeactivationReason]);

  // * RENDER
  return (
    <BaseDialog
      open={open}
      handleClose={onClose}
      title={title}
      actions={renderActions}
      content={renderContent}
      fullScreen={isMobileSize}
      contentSize="small"
      TransitionComponent={isMobileSize ? SlideUpTransition : undefined}
    />
  );
};

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  text: {
    fontSize: 14,
    color: theme.palette.text.primary,
    width: '100%'
  },
  bold: {
    fontWeight: 600
  }
}));

export default DeactivationReasonStep;
